import Vue from 'vue'
import VueRouter from 'vue-router'
import { Platform } from 'quasar'

Vue.use(VueRouter)

var url = "/locks";

function load(component) {
  console.log("Router.load Platform.is.cordova:");
  if (Platform.is.cordova) {
    url = "/scan";
  }

  // '@' is aliased to src/components
  return () => import(`@/${component}.vue`)
}

export default new VueRouter({
  /*
   * NOTE! VueRouter "history" mode DOESN'T works for Cordova builds,
   * it is only to be used only for websites.
   *
   * If you decide to go with "history" mode, please also open /config/index.js
   * and set "build.publicPath" to something other than an empty string.
   * Example: '/' instead of current ''
   *
   * If switching back to default "hash" mode, don't forget to set the
   * build publicPath back to '' so Cordova builds work again.
   */

  routes: [
    { path: '/login', name: 'login', component: load('Login') },
    { path: '/cookies', name: 'cookies', component: load('Cookies') },
    {
      path: '/',
      name: 'home',
      component: load('Home'),
      redirect: url,
      children: [
        { path: 'scan', name: 'scan', component: load('Scan') },
        { path: 'locks', name: 'locks', component: load('Locks') },
        { path: 'keys', name: 'keys', component: load('UserKeys') },
        { path: 'groups', name: 'groups', component: load('Groups') },
        { path: 'groups/:groupId', name: 'groupEdit', component: load('GroupEdit'), props: true },
        { path: 'groups/:groupId/members/:email', name: 'groupMemberEdit', component: load('GroupMemberEdit'), props: true },
        { path: 'admin', name: 'admin', component: load('Admin') },
        { path: 'settings', name: 'settings', component: load('Settings') },
        { path: 'about', name: 'about', component: load('About') },
        { path: 'manufacturer', name: 'manufacturer', component: load('Manufacturer') },
        { path: 'locks/:lockId', name: 'lockEdit', component: load('LockEdit'), props: true },
        { path: 'locks/:lockId/keys/:emailOrGroupId', name: 'lockKeyEdit', component: load('LockKeyEdit'), props: true },
        { path: 'keys/:keyIndex', name: 'keyDetails', component: load('KeyDetails'), props: true }
      ]
    },

    // Always leave this last one
    { path: '*', component: load('Error404') } // Not found
  ]
})



// WEBPACK FOOTER //
// ./src/router.js